<template>
  <div>
    <VehiclesProviderPriceNav />
    <div>
      <div>
        <b-row>
          <b-col>
            <h4 class="ml-3 mt-2">Provider price</h4>
          </b-col>
        </b-row>
        <b-row class="mb-1 mr-1 ml-1">
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="">
            <b-form-group label="Provider:">
              <vue-multiselect
                v-model="search"
                id="ajax"
                label="name"
                track-by="name"
                placeholder="Type to search"
                open-direction="bottom"
                :options="providersList"
                :multiple="false"
                :searchable="true"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :max-height="600"
                :show-no-results="true"
                :hide-selected="true"
                :selectLabel="''"
              >
                <template slot="tag" slot-scope="{ option, remove }"
                  ><span class="custom__tag"
                    ><span>{{ option.name }}</span
                    ><span class="custom__remove" @click="remove(option)"
                      >❌</span
                    ></span
                  ></template
                >
              </vue-multiselect>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="">
            <b-form-group label="From:">
              <b-form-datepicker
                id="example-datepicker-from"
                v-model="dateFrom"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="">
            <b-form-group label="To:">
              <b-form-datepicker
                id="example-datepicker-to"
                v-model="dateTo"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="mt-1">
            <b-button variant="success" class="mt-4 mr-1" @click="getData()">
              <b-icon icon="search"></b-icon> Search
            </b-button>
            <b-button
              variant="outline-success"
              class="mt-4"
              @click="downloadXL()"
            >
              <b-icon icon="file-spreadsheet"></b-icon> Download
            </b-button>
          </b-col>
        </b-row>
        <b-container v-if="isFieldsReady" class="pt-4">
          <div class="">
            <b-table
              thead-class="text-center bg-light-grey "
              head-variant="light"
              bordered
              small
              show-empty
              outlined
              stacked="md"
              :fields="fields"
              :items="vehiclesPriceBySupplier"
              id="tableMain"
              :busy="isLoadingProviders"
              responsive
            >
              <template #empty>
                <div class="text-center">
                  <h6>{{ $t("thereAreNoRecordsToShow") }}</h6>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner variant="primary" class="align-middle"></b-spinner>
                  <p>Loading</p>
                </div>
              </template>
              <template
                v-for="field in dates"
                v-slot:[`cell(${field})`]="{ item }"
              >
                <span :key="field">
                  {{ item[field] ? item[field].price : "-" | currency }}
                  <b-icon
                    icon="pencil-fill"
                    class="cursor-pointer"
                    variant="info"
                    @click="editPrice(item, field)"
                  ></b-icon>
                </span>

                <!-- 
                <b-button
                  size="sm"
                  variant="primary"
                >
                  Editar precio
                </b-button> -->
              </template>

              <template v-slot:cell(actions)="row">
                <div class="text-center">
                  <b-form-group>
                    <b-icon
                      v-b-tooltip.hover
                      title="Details"
                      icon="eye"
                      class="h5 m-2 cursor-pointer"
                      @click="
                        () => {
                          row.toggleDetails();
                          getVehiclePrices(row.item);
                        }
                      "
                    ></b-icon>
                    <b-icon
                      v-b-tooltip.hover
                      title="Delete"
                      v-if="row.field.delete"
                      :icon="row.item.status !== 1 ? 'toggle-off' : 'toggle-on'"
                      class="h5 m-2"
                      @click="
                        row.item.status !== 1
                          ? activateItem(row.item)
                          : deleteItem(row.item)
                      "
                    ></b-icon>
                  </b-form-group>
                </div>
              </template>
            </b-table>
          </div>
        </b-container>
      </div>
    </div>

    <b-modal
      ref="providerPriceModal"
      id="providerPriceModal"
      size="lg"
      hide-footer
      body-class="pl-0 pr-0"
      ok-disabled
      @hidden="providerItem = {}"
    >
      <ProviderPriceForm
        :vehicleId="vehicleId"
        :refreshData="getData"
        :hideModal="hideModal"
        :providerItem="providerItem"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  GET_PRICE_BY_PROVIDER,
  GET_PRICE_XLS,
  GET_SUPPLIERS_LIST,
} from "./actions";
import VehiclesProviderPriceNav from "./VehiclesProviderPriceNav.vue";
import ProviderPriceForm from "./ProviderPriceForm.vue";
import { mapState } from "vuex";
export default {
  name: "PriceByProviderTable",
  components: {
    VehiclesProviderPriceNav,
    ProviderPriceForm,
  },

  computed: {
    ...mapState({
      vehiclesPriceBySupplier: (state) =>
        state.adminStore.vehiclesProviderPrice.vehiclesPriceBySupplier.data,
      isLoadingProviders: (state) =>
        state.adminStore.vehiclesProviderPrice.vehiclesPriceBySupplier.status ==
        "fetching",
      providersList: (state) =>
        state.adminStore.vehiclesProviderPrice.providersList.data,
    }),
  },
  data() {
    return {
      search: "",
      dateFrom: null,
      dateTo: null,
      fields: [
        { key: "vin", label: "Vin", class: "text-center" },
        {
          key: "year",
          label: "year",
          class: "text-center",
        },
        { key: "make", label: "Make", class: "text-center" },
        { key: "model", label: "Model", class: "text-center" },
        { key: "trim", label: "Trim", class: "text-center" },
        { key: "kms", label: "Mileage", class: "text-center" },
      ],
      dates: [],
      isFieldsReady: false,
      providerItem: {},
      vehicleId: null,
    };
  },
  mounted() {
    /*     this.getData();
     */
    this.getSupplierList();
  },
  methods: {
    getData() {
      const payload = {
        id: this.search ? this.search.id : null,
        dateFrom: this.dateFrom ? this.dateFrom : null,
        dateTo: this.dateTo ? this.dateTo : null,
      };
      this.$store.dispatch(GET_PRICE_BY_PROVIDER, payload).then((response) => {
        this.dates = response.dates;
        this.formatData(response.dates);
      });
    },
    getSupplierList() {
      this.$store
        .dispatch(GET_SUPPLIERS_LIST)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Error fetching suppliers list:", error);
        });
    },
    formatData(dates) {
      dates.forEach((date) => {
        this.fields.push({
          key: date,
          label: date,
          class: "text-center",
          formatter: (price) => this.$options.filters.currency(price.price),
        });
      });
      this.isFieldsReady = true;
    },
    downloadXL() {
      const payload = {
        id: this.search ? this.search.id : null,
        dateFrom: this.dateFrom ? this.dateFrom : null,
        dateTo: this.dateTo ? this.dateTo : null,
        type: "suppliers",
      };
      this.$store.dispatch(GET_PRICE_XLS, payload).then((response) => {
        const blob = new Blob([response], {
          type: "application/vnd.ms-excel",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download =
          this.formatFileName("suppliers") + ".xls" || "ficher.xls";
        link.click();
      });
    },
    formatFileName(type) {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${type}-${year}-${month}-${day}`;
    },
    editPrice(item, field) {
      this.providerItem = {
        id: item[field].id,
        supplierId: item[field].suppliers_id,
        price: item[field].price,
        date: item[field].date,
        vehicleId: item[field].vehicles_id,
      };

      this.$bvModal.show("providerPriceModal");
    },
    hideModal() {
      this.$bvModal.hide("providerPriceModal");
      this.providerItem = {};
    },
  },
};
</script>
<style scoped></style>
